import styled from "styled-components";

export const AuthContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding-top: 30px;
    margin-inline: 10px;

    @media only screen and (min-width: 501px) {
        width: 500px;
        margin-inline: auto;
    }
`